module.exports = __webpack_public_path__ + "img/signature-gray.c1ba213f.svg";